export const theme = {
  colors: {
    blue: "#23BED0",
    blueHover: "#1F9FAE",
    orange: "#E56225",
    black: "#333",
    gray: "#575757",
    white: "#FAFAFA",
  },
};
